import { GenericBaseParameter } from "../base-parameter";
import { PagingListResponse } from "../listing-base-model";
import { IMessageNotificationListingModel } from "./index";

export interface IMessageNotificationParameterModel {
  UserIds?: number[];
  FromDate?: string;
  ToDate?: string;
  Ids?: number[];
  ExcludeIds?: number[];
  IsDeleted?: boolean;
  IsRead?: boolean;
  Search?: string;
}

export class MessageNotificationParameter implements IMessageNotificationParameterModel {
  UserIds?: number[];
  FromDate?: string;
  ToDate?: string;
  Ids?: number[];
  ExcludeIds?: number[];
  IsDeleted?: boolean;
  IsRead?: boolean;
  Search?: string;
  constructor(options?: IMessageNotificationParameterModel) {
    this.UserIds = options && options.UserIds ? options.UserIds : [];
    this.Ids = options && options.Ids ? options.Ids : [];
    this.ExcludeIds = options && options.ExcludeIds ? options.ExcludeIds : [];
    this.FromDate = options && options.FromDate ? options.FromDate : null;
    this.ToDate = options && options.ToDate ? options.ToDate : null;
    this.IsDeleted = options && options.IsDeleted ? options.IsDeleted : false;
    this.IsRead = (options || {}).IsRead || null;
    this.Search = options && options.Search ? options.Search : null;
  }
}

export class MessageNotificationResquest extends GenericBaseParameter<IMessageNotificationParameterModel> {
  DisplayLanguage: number;
  IsOnlyGetTotalRecords: boolean = true;

  /**
    *
    */
  constructor(pageIndex?: number, pageSize?: number, orderBy?: string, fields?: string, condition?: IMessageNotificationParameterModel) {
    super(pageIndex, pageSize, orderBy, fields, condition);
  }
}

export class MessageNotificationResponse extends PagingListResponse<IMessageNotificationListingModel> {
  /**
    *
    */
  constructor() {
    super();
  }
}